import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {GlobalService} from 'app/global/global.service';
import {HelperService} from 'app/main/pages/edit-template/helper.service';
import {InviteToReadService} from './invite-to-read.service';


@Component({
  selector: 'app-invite-to-read',
  templateUrl: './invite-to-read.component.html',
  styleUrl: './invite-to-read.component.scss'
})
export class InviteToReadComponent implements OnInit {
  
  @Input() roleId: number;
  @Input() document_id: number;
  @Input() is_sender: number;

  public inviteToRead: FormGroup;
  public submitted: boolean = false;
  public inviteToReadLoader: boolean = false;
  
  constructor(
    private formBuilder: FormBuilder,
    private globalService: GlobalService,
    private helperService: HelperService,
    public activeModal: NgbActiveModal,
    private inviteToReadService:InviteToReadService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(){
    this.inviteToRead = this.formBuilder.group({
      recipient: this.formBuilder.group({
        firstname: ['', Validators.required],
        lastname: [''],
        email: ['', [Validators.required, Validators.email]],
        phone_no: [''],
        persnol_no: [''],
        address: [''],
        city: [''],
        zipcode: ['']
      }),
      invitation_type: ['email'],
      message: ['']
    })
  }



  onSubmit() {
    this.submitted = true;
    if (this.inviteToRead.invalid) {
      return;
    }
    this.submitted = false;
    this.inviteToReadLoader = true;
    this.inviteToReadService.inviteToRead(this.roleId, this.document_id, this.newRole()).subscribe(
      {
        next: () => {
          window.location.reload();
        },
        error: (error) => {
          this.globalService.toastrError(error);
          this.inviteToReadLoader = false;
        }
      }
    )
  }



  newRole(){
    const newRole = this.formBuilder.group({
      document_id: this.document_id,
      role_name: ['Recipient 1'],
      role_color: this.globalService.generateRandomColor(),
      sender_as_role: [0],
      recipient_id: [null],
      organization_id: [null],
      invitation_type: ['email'],
      invitation_order: [1],
      authentication_type: ['read_only'],
      authentication_required: [true],
      confirmation_type: ['email'],
      signature_confirmation: [''],
      personfields: this.formBuilder.array(this.helperService.getPersonfields([], this.getFilteredForm('recipient'), false, false)),
      orgfields: this.formBuilder.array(this.helperService.getOrgfields([], {}, false, false)),
      recipient: this.getFilteredForm('recipient'),
      organization: null,
      message: this.getFilteredForm('message')
    });
    return newRole.value;
  }


  /**
   * Get form value behalf on key
   * @param key 
   * @returns Form value
   */
  getFilteredForm(key: string){
    const formData = {...this.inviteToRead.value};
    if(formData?.recipient?.phone_no){
      formData.recipient.phone_no = formData?.recipient?.phone_no?.e164Number;
    }
    return key ? formData[key] : formData;
  }

}
